var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-sm-12" },
      [
        _c("table-data", {
          attrs: {
            title: _vm.pageTitle,
            route: _vm.url,
            expandFilters: _vm.table.expandFilters,
            settings: _vm.table.settings,
            columns: _vm.table.columns,
            inlineFilters: _vm.table.filters,
            autoUpdateFilter: _vm.table.autoUpdateFilter,
            addParamsToUrl: _vm.table.addParamsToUrl,
            loadingMsg: _vm.table.loadingMsg,
            notFoundMsg: _vm.table.notFoundMsg,
            orderByTemplate: _vm.table.orderByTemplate,
            tableClass: "table-responsive-sm",
          },
          on: { "error-load": _vm.showError },
          scopedSlots: _vm._u([
            {
              key: "filters-body",
              fn: function ({ tableFilters }) {
                return [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showModules,
                            expression: "showModules",
                          },
                        ],
                        staticClass: "col-12 col-sm-3",
                      },
                      [
                        _c(
                          "MaterialSelect",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "",
                                expression: "''",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              id: "input-module",
                              name: "module",
                              label: "name",
                              options: _vm.modules,
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("module") },
                              ],
                              error: _vm.fnFirstError("module"),
                            },
                            model: {
                              value: tableFilters.module,
                              callback: function ($$v) {
                                _vm.$set(
                                  tableFilters,
                                  "module",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableFilters.module",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t(`${_vm.pageID}.search.module`)) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-3" },
                      [
                        _c(
                          "MaterialSelect",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "",
                                expression: "''",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              id: "input-channel",
                              name: "channel",
                              label: "name",
                              options: _vm.channels,
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("channel") },
                              ],
                              error: _vm.fnFirstError("channel"),
                            },
                            model: {
                              value: tableFilters.channel,
                              callback: function ($$v) {
                                _vm.$set(
                                  tableFilters,
                                  "channel",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableFilters.channel",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t(`${_vm.pageID}.search.channel`)) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-12",
                        class: [_vm.showModules ? "col-sm-6" : "col-sm-9"],
                      },
                      [
                        _c(
                          "MaterialDateRangePicker",
                          {
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              id: "input-created_at",
                              name: "created_at",
                              dateFormat: _vm.labelDateFormat,
                              clearButton: true,
                              showTime: false,
                              singleDatePicker: false,
                              showDropdowns: true,
                            },
                            model: {
                              value: tableFilters.created_at,
                              callback: function ($$v) {
                                _vm.$set(
                                  tableFilters,
                                  "created_at",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableFilters.created_at",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(`${_vm.pageID}.search.created_at`)
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-5" },
                      [
                        _c(
                          "MaterialInput",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "min:3",
                                expression: "'min:3'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              type: "text",
                              id: "input-recipients",
                              name: "recipients",
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("recipients") },
                              ],
                              error: _vm.fnFirstError("recipients"),
                            },
                            model: {
                              value: tableFilters.recipients,
                              callback: function ($$v) {
                                _vm.$set(
                                  tableFilters,
                                  "recipients",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableFilters.recipients",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(`${_vm.pageID}.search.recipients`)
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-7" },
                      [
                        _c(
                          "MaterialInput",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "min:3",
                                expression: "'min:3'",
                              },
                            ],
                            staticClass: "city-form-group city-bg",
                            attrs: {
                              type: "text",
                              id: "input-content",
                              name: "content",
                              inputClasses: [
                                { "is-invalid": _vm.fnHasError("content") },
                              ],
                              error: _vm.fnFirstError("content"),
                            },
                            model: {
                              value: tableFilters.content,
                              callback: function ($$v) {
                                _vm.$set(
                                  tableFilters,
                                  "content",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "tableFilters.content",
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t(`${_vm.pageID}.search.content`)) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
            },
            {
              key: "body",
              fn: function ({ row, index }) {
                return [
                  _c("td", {
                    class: _vm.table.columns[0].class,
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.columnValue(row, _vm.table.columns[0])
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("td", {
                    class: _vm.table.columns[1].class,
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.columnValue(row, _vm.table.columns[1])
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("td", { class: _vm.table.columns[2].class }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.columnValue(row, _vm.table.columns[2])) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", { class: _vm.table.columns[3].class }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.columnValue(row, _vm.table.columns[3])) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.checkActions
                    ? _c("column-actions", {
                        attrs: {
                          routeEdit: _vm.routeEdit,
                          canDetail: _vm.canDetail,
                          canEdit: false,
                          canDelete: false,
                          row: row,
                          index: index,
                        },
                      })
                    : _vm._e(),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }